import { forwardRef, useRef } from "react";
import { Button } from "./button";
import { MinusCircle, PlusCircle } from "lucide-react";
import { mergeRefs } from "@/src/lib/utils";

export type ScoreSelectProps = {
  min: number;
  max: number;
  value: number;
  onChange?: (value: number) => void;
  disabled?: boolean;
};

export const ScoreSelect = forwardRef<HTMLDivElement, ScoreSelectProps>((props, ref) => {
  const { value, min, max, onChange, disabled } = props;

  const plusDisabled = value === max || disabled;
  const minusDisabled = value === min || disabled;

  const internalRef = useRef<HTMLDivElement>(null);

  return (
    <div className="flex flex-row items center gap-3">
      <Button
        disabled={minusDisabled}
        onClick={(ev) => {
          ev.preventDefault();
          internalRef.current?.focus();
          onChange?.(value - 1);
        }}
        className="text-slate-500 p-0 b-0 bg-transparent hover:bg-transparent"
      >
        <MinusCircle />
      </Button>

      <div ref={mergeRefs(internalRef, ref)} className="rounded-md h-10 w-12 px-3 py-2 border flex justify-center">
        {value}
      </div>

      <Button
        disabled={plusDisabled}
        onClick={(ev) => {
          ev.preventDefault();
          internalRef.current?.focus();
          onChange?.(value + 1);
        }}
        className="text-slate-500 p-0 b-0 bg-transparent hover:bg-transparent"
      >
        <PlusCircle />
      </Button>
    </div>
  );
});

ScoreSelect.displayName = "ScoreSelect";
